import React from "react";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody";
import AnimatedTitle from "../animations/AnimatedTitle";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
      id="about"
    >
      <div className="mx-auto flex w-[90%] flex-col  lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={"ABOUT ME"}
          className={
            "mb-10 text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />

        <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row lg:gap-20">
          <div className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16  lg:max-w-[90%] lg:text-[24px] ">
            <AnimatedBody text="Hi, I'm Sahindu Gayanuka, currently studying Computer Security at Plymouth University. I'm deeply interested in cybersecurity, software engineering, and emerging technologies. I enjoy understanding how systems work, pushing their limits, and building solutions that are clean, efficient, and actually make sense." />

            <AnimatedBody
              delay={0.1}
              text="I spend my time building software, experimenting with new tech, and staying up to date with the latest tools and practices. Whether it's backend systems, UI/UX, automation, or infrastructure — I like being hands-on and learning by doing."
            />

            <AnimatedBody
              delay={0.2}
              text="Outside academics, I run AssembleX, a digital agency where I design and develop modern tech solutions — websites, apps, cloud integrations, and everything in between. Clean architecture and good design are things I take seriously."
            />

            <AnimatedBody
              delay={0.3}
              text="When I'm not coding, I'm gaming, watching movies, or deep-diving into random tech topics at 3AM. Basically, I learn things I absolutely did not plan to learn."
            />

            <motion.div
              initial={{ opacity: 0, y: "1em" }}
              whileInView={{ opacity: 1, y: "0em" }}
              viewport={{ once: true }}
              transition={{
                delay: 0.4,
                duration: 1,
                ease: [0.2, 0.65, 0.3, 0.9],
              }}
            >
              Always open to new ideas, collaborations, and conversations — feel
              free to{" "}
              <a
                href="mailto:contact@sahiya.lk"
                className="text-[#95979D] underline transition-colors hover:text-white"
                data-blobity
                data-blobity-radius="24"
              >
                reach out
              </a>
              .
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
